import {ArtfactKind, IEntity, Metadata, Search} from '@mrp-brasil/nick-data-commons';
import {ICoreCrudService} from '@mrp-brasil/nick-node-commons';
import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import moment from 'moment';
import momentTz from 'moment-timezone';
import {from, Observable, of} from 'rxjs';
import {concatMap, map, takeWhile, toArray} from 'rxjs/operators';
import {CronJob} from 'cron';

enum OperationKind {
    PLUS = 0,
    MINUS = 1,
    DIFF = 2,
    START = 3,
    END = 4
}

enum OperationType {
    YEAR = 'y',
    MONTH = 'm',
    DAY = 'd',
    HOURS = 'h',
    MINUTES = 'M',
    SECONDS = 's'
}

@HookClass('date')
export class DateHook extends BaseHook {

    /*
     * @deprecated
     */
    @Hook('3d224630-0df3-458e-97b9-c34a9d4cad82')
    public set(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const fields = Object.keys(inputArtifact.object.map);
        return from(fields)
            .pipe(map((field: any) => {
                const fn = inputArtifact.object.map[field];
                inputArtifact.object.data[field] = new Date();
                const values = fn.val.match(/(\d+)(\D+)/);

                if (values.length > 2) {
                    const value = values[1];
                    const quantify = values[2];
                    switch (fn.op) {
                        case 'plus':
                            inputArtifact.object.data[field].setDate(new Date().getDate() + parseInt(value, 10));
                            break;
                    }
                }

            }), toArray())
            .pipe(concatMap(() => of(inputArtifact)));
    }

    @Hook('f53ac677-cb59-4cdd-8d3c-172e5902ca0a')
    public operations(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = {};

        return from(inputArtifact.object.operations)
            .pipe(map((operation: any) => {
                if (operation.value == undefined)
                    operation.value = 0;

                if (operation.reference) {
                    if (operation.reference.startsWith && operation.reference.startsWith('...'))
                        operation.reference = moment(outputArtifact.object[operation.reference.replace('...', '')]);
                    else
                        operation.reference = moment(operation.reference);
                }

                if (!operation.reference)
                    operation.reference = moment(new Date());
                else if (!operation.reference.isValid()) {
                    outputArtifact.object[operation.as] = null;
                    return;
                }

                switch (operation.kind) {
                    case OperationKind.PLUS: {
                        switch (operation.type) {
                            case OperationType.YEAR:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'years').toDate();
                                break;
                            case OperationType.MONTH:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'months').toDate();
                                break;
                            case OperationType.DAY:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'days').toDate();
                                break;
                            case OperationType.HOURS:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'hours').toDate();
                                break;
                            case OperationType.MINUTES:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'minutes').toDate();
                                break;
                            case OperationType.SECONDS:
                                outputArtifact.object[operation.as] = (operation.reference).add(operation.value, 'seconds').toDate();
                                break;
                        }
                        break;
                    }
                    case OperationKind.MINUS: {
                        switch (operation.type) {
                            case OperationType.YEAR:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'years').toDate();
                                break;
                            case OperationType.MONTH:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'months').toDate();
                                break;
                            case OperationType.DAY:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'days').toDate();
                                break;
                            case OperationType.HOURS:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'hours').toDate();
                                break;
                            case OperationType.MINUTES:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'minutes').toDate();
                                break;
                            case OperationType.SECONDS:
                                outputArtifact.object[operation.as] = (operation.reference).subtract(operation.value, 'seconds').toDate();
                                break;
                        }
                        break;
                    }
                    case OperationKind.DIFF: {
                        switch (operation.type) {
                            case OperationType.YEAR:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'years');
                                break;
                            case OperationType.MONTH:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'months');
                                break;
                            case OperationType.DAY:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'days');
                                break;
                            case OperationType.HOURS:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'hours');
                                break;
                            case OperationType.MINUTES:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'minutes');
                                break;
                            case OperationType.SECONDS:
                                outputArtifact.object[operation.as] = (operation.reference).diff(operation.value, 'seconds');
                                break;
                        }
                        break;
                    }
                    case OperationKind.START: {
                        switch (operation.type) {
                            case OperationType.YEAR:
                                outputArtifact.object[operation.as] = (operation.reference).startOf('year').toDate();
                                break;
                            case OperationType.MONTH:
                                outputArtifact.object[operation.as] = (operation.reference).startOf('month').toDate();
                                break;
                            case OperationType.DAY:
                                outputArtifact.object[operation.as] = (operation.reference).startOf('day').toDate();
                                break;
                            case OperationType.HOURS:
                                outputArtifact.object[operation.as] = (operation.reference).startOf('hours').toDate();
                                break;
                            case OperationType.MINUTES:
                                outputArtifact.object[operation.as] = (operation.reference).startOf('minutes').toDate();
                                break;
                        }
                        break;
                    }
                    case OperationKind.END: {
                        switch (operation.type) {
                            case OperationType.YEAR:
                                outputArtifact.object[operation.as] = (operation.reference).endOf('year').toDate();
                                break;
                            case OperationType.MONTH:
                                outputArtifact.object[operation.as] = (operation.reference).endOf('month').toDate();
                                break;
                            case OperationType.DAY:
                                outputArtifact.object[operation.as] = (operation.reference).endOf('day').toDate();
                                break;
                            case OperationType.HOURS:
                                outputArtifact.object[operation.as] = (operation.reference).endOf('hours').toDate();
                                break;
                            case OperationType.MINUTES:
                                outputArtifact.object[operation.as] = (operation.reference).endOf('minutes').toDate();
                                break;
                        }
                        break;
                    }
                }

            }), toArray())
            .pipe(concatMap(() => {
                return of(outputArtifact);
            }));
    }

    @Hook('e8106e5e-fcac-4e16-b504-69e52b4ccb71')
    public get(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        const date = moment(inputArtifact.object.data);
        outputArtifact.object = date.get(inputArtifact.object.config.unit);

        return of(outputArtifact);
    }

    @Hook('11b82c46-b350-4d92-b1b1-e5efaa0949fe')
    public age(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const date = moment(inputArtifact.object.data);

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = moment().diff(date, 'years');
        return of(outputArtifact);
    }

    @Hook('2ed54dee-ebe1-4c07-9e97-d795d7beeb4f')
    public now(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = new Date();

        return of(outputArtifact);
    }

    @Hook('3a5e9094-1630-446b-8b3f-2d16c1ffab07')
    public format(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(Object.keys(inputArtifact.object.data))
            .pipe(map((key: string) => {
                let locale = inputArtifact.object.config?.locale ? inputArtifact.object.config.locale : 'pt-br';
                moment.locale(locale);
                let date: any = moment(!inputArtifact.object.data[key] ? new Date() : inputArtifact.object.data[key]);

                if (inputArtifact.object.config.timeZone)
                    date = date.tz(inputArtifact.object.config.timeZone);

                inputArtifact.object.data[key] = date.format(inputArtifact.object.config.format).toString();
            }), toArray())
            .pipe(concatMap(() => {
                return of(inputArtifact);
            }));
    }

    @Hook('295ecbb4-2f65-4bd3-8a4b-26098302e2ad')
    public parse(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(Object.keys(inputArtifact.object.data))
            .pipe(map((key: string) => {
                inputArtifact.object.data[key] = moment(inputArtifact.object.data[key], inputArtifact.object.config.format).toDate();
            }), toArray())
            .pipe(concatMap(() => {
                return of(inputArtifact);
            }));
    }

    @Hook('c0a345d8-50ea-4a19-b7ed-0f982aa75b64')
    public availableSeriesWorksheet(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const seriesField = 'day';
        const seriesEndField = 'dayEnd';
        let timeZone = 'America/Sao_Paulo';
        let seriesDuration = '60';

        if (inputArtifact.object?.config?.timeZone)
            timeZone = inputArtifact.object?.config?.timeZone;

        if (inputArtifact.object?.config?.seriesDuration)
            seriesDuration = inputArtifact.object?.config?.seriesDuration;

        let selectedDateStart: any;
        let selectedDateEnd: any;
        let maxDate: any;
        let minDate: any;

        if (inputArtifact.object.config.range) {
            selectedDateStart = momentTz(inputArtifact.object.config.range[0]).format('YYYY-MM-DD HH:mm:ss');
            selectedDateEnd = momentTz(inputArtifact.object.config.range[1]).format('YYYY-MM-DD HH:mm:ss');
        }

        if (inputArtifact.object.config.minDate)
            minDate = momentTz(inputArtifact.object.config.minDate).format('YYYY-MM-DD HH:mm:ss');

        if (inputArtifact.object.config.maxDate)
            maxDate = momentTz(inputArtifact.object.config.maxDate).format('YYYY-MM-DD HH:mm:ss');

        const startField = inputArtifact.object?.config?.startField;
        const endField = inputArtifact.object?.config?.endField;

        return this.crud(inputArtifact.object.model)
            .pipe(concatMap((service: ICoreCrudService) => {

                let include: any[] = null;
                let exclude: any[] = null;
                const insideAttributes: any[] = [];
                const includeAttributes = new Map<string, any[]>();

                if (inputArtifact.object.config && inputArtifact.object.config.include) {
                    include = inputArtifact.object.config.include;

                    const organize$ = (include: any[], associations: any, level: number) => {
                        include.forEach((item: any) => {
                            item.attributes = item.attributes ? item.attributes : [];
                            item.model = associations[item.as].target;
                            item.association = associations[item.as];
                            item.parent = {model: associations[item.as].source};

                            if (item.attributes)
                                includeAttributes.set(item.as, item.attributes);

                            if (level == 0)
                                insideAttributes.push(item.association.foreignKey);

                            if (item.include)
                                organize$(item.include, item.model.associations, ++level);
                        });
                    };

                    organize$(include, service.associations, 0);
                }

                // organize exclude tables
                if (inputArtifact.object.config && inputArtifact.object.config.exclude) {
                    exclude = inputArtifact.object.config.exclude;

                    const organize$ = (include: any[], associations: any, level: number) => {
                        include.forEach((item: any) => {
                            if (!associations[item.as])
                                item.model = service.repository.instance.models[item.as];
                            else {
                                item.model = associations[item.as].target;
                                item.association = associations[item.as];
                                item.parent = {model: associations[item.as].source};
                            }

                            if (item.include)
                                organize$(item.include, item.model.associations, ++level);
                        });
                    };

                    organize$(exclude, service.associations, 0);
                }

                const search = new Search(inputArtifact.object.data);
                return service.getMetadata()
                    .pipe(concatMap((metadata: Metadata) => {

                        search.setMetadata(metadata);
                        return search.buildWhere()
                            .pipe(concatMap((_where: any) => {
                                if (_where.length)
                                    _where = {$or: Search.literalFn(_where)};

                                // func to generate series
                                const generateSeriesRef = service.fn(
                                    'generate_series',
                                    service.col(`${metadata.modelTableName}.${startField}`),
                                    service.col(`${metadata.modelTableName}.${endField}`),
                                    `${seriesDuration} minute`);

                                const dateTruncRef = service.fn(
                                    'date_trunc',
                                    'second',
                                    generateSeriesRef);

                                // const startColumn = service.literal(`"${startField}" at time zone '${timeZone}' as "${startField}"`);
                                // const endColumn = service.literal(`"${endField}" at time zone '${timeZone}' as "${endField}"`);
                                const startColumn = service.literal(`"${metadata.modelTableName}"."${startField}" as "${startField}"`);
                                const endColumn = service.literal(`"${metadata.modelTableName}"."${endField}" as "${endField}"`);

                                if (!inputArtifact.object.config.attributes)
                                    inputArtifact.object.config.attributes = [];

                                // add series attribute and concat with fields user requested
                                let attributes: any = [[dateTruncRef, seriesField], startColumn, endColumn].concat(insideAttributes);

                                const externalWhere: any = {
                                    $and: []
                                };

                                // filter by min date
                                if (inputArtifact.object.config.minDate)
                                    externalWhere.$and.push({day: {$gt: minDate}});

                                // filter by max date
                                if (inputArtifact.object.config.maxDate)
                                    externalWhere.$and.push({day: {$lte: maxDate}});

                                // filter hours between range
                                if (inputArtifact.object.config.range)
                                    externalWhere.$and.push({day: {$between: [selectedDateStart, selectedDateEnd]}});

                                // filter hour between worksheet start and end
                                const datePartHour = service.fn(
                                    'date_part',
                                    'HOUR',
                                    service.repository.model.sequelize.col(`"${metadata.modelTableName}".${seriesField}`));

                                const dateStartAtPartHour = service.fn(
                                    'date_part',
                                    'HOUR',
                                    service.repository.model.sequelize.col(`"${metadata.modelTableName}".${startField}`));

                                const dateEndAtPartHour = service.fn(
                                    'date_part',
                                    'HOUR',
                                    service.repository.model.sequelize.col(`"${metadata.modelTableName}".${endField}`));

                                externalWhere.$and.push(service.where(datePartHour, {$gte: dateStartAtPartHour}));
                                externalWhere.$and.push(service.where(datePartHour, {$lte: dateEndAtPartHour}));

                                // filter weekDays in worksheet (Example: weekday 1,2,3)
                                if (inputArtifact.object.config.weekDaysField) {
                                    const datePartDOW = service.fn(
                                        'date_part',
                                        'DOW',
                                        service.repository.model.sequelize.col(`"${metadata.modelTableName}".${seriesField}`));

                                    externalWhere.$and.push(service.where(datePartDOW, service.literal(`ANY (string_to_array("${metadata.modelTableName}"."${inputArtifact.object.config.weekDaysField}", ',')::int[])`)));

                                    attributes = attributes.concat([inputArtifact.object.config.weekDaysField]);
                                }

                                if (exclude?.length) {
                                    // prevent collision between other event table, comparing startAt and endAt fields
                                    exclude.forEach((excludeItem: any) => {
                                        const $and = [];
                                        const $or = [];

                                        excludeItem.where = {$and: excludeItem.where ? [excludeItem.where] : []};

                                        const replaceFields = new Map<string, string>();

                                        if (excludeItem.joinBy) {
                                            excludeItem.joinBy.forEach((joinColumn: string) => {
                                                replaceFields.set(`'...${metadata.modelTableName}.${joinColumn}'`, `"${metadata.modelTableName}"."${joinColumn}"`);
                                            });
                                        }

                                        // ("worksheet"."day" >= "room"."startAt" AND "worksheet"."day" < "room"."endAt") OR
                                        // ("worksheet"."day" < "room"."startAt" AND ("worksheet".day + INTERVAL '60 minutes') > "room"."startAt")

                                        const seriesColumn = service.literal(`"${metadata.modelTableName}".${seriesField}`);
                                        const seriesEndColumn = service.literal(`("${metadata.modelTableName}".${seriesField} + INTERVAL '${seriesDuration} minutes')`);
                                        const startColumn = service.literal(`"${excludeItem.as}"."${excludeItem.field.start}"`);
                                        const endColumn = service.literal(`"${excludeItem.as}"."${excludeItem.field.end}"`);

                                        $or.push({
                                            $and: [
                                                service.where(seriesColumn, {$gte: startColumn}),
                                                service.where(seriesColumn, {$lt: endColumn})
                                            ]
                                        });

                                        $or.push({
                                            $and: [
                                                service.where(seriesColumn, {$lt: startColumn}),
                                                service.where(seriesEndColumn, {$gt: startColumn})
                                            ]
                                        });

                                        excludeItem.where.$and.push({$or});

                                        let excludeQuery = excludeItem.model.QueryGenerator.selectQuery(excludeItem.model.tableName, {
                                            where: excludeItem.where,
                                            tableAs: excludeItem.as,
                                            include: excludeItem.include,
                                            attributes: excludeItem.attributes,
                                            model: excludeItem.model
                                        }, service.repository.model);

                                        Array.from(replaceFields.keys()).forEach((key: string) => {
                                            excludeQuery = excludeQuery.replace(new RegExp(`${key}`, 'g'), replaceFields.get(key));
                                        });

                                        excludeQuery = excludeQuery.replace(`SELECT *`, `SELECT "${excludeItem.as}"."${excludeItem.field.start}"`).slice(0, -1);
                                        excludeQuery = excludeQuery.replace(`SELECT "${excludeItem.as}".*`, `SELECT "${excludeItem.as}"."${excludeItem.field.start}"`);

                                        externalWhere.$and.push(service.where(service.literal(`(${excludeQuery})`), {$is: null}));


                                        // $and.push(service.where(service.literal(`"${excludeModel}"`), {$eq: null}));
                                        // $or.push(service.where(service.repository.model.sequelize.col(`"${metadata.modelTableName}".${seriesField}`), {$gte: service.literal(`"${excludeModel}"."${excludeInfo.endField}"`)}));
                                        //
                                        // const $subAnd = [];
                                        // $subAnd.push(service.where(service.repository.model.sequelize.col(`"${metadata.modelTableName}".${seriesField}`), {$lt: service.literal(`"${excludeModel}"."${excludeInfo.startField}"`)}));
                                        // $subAnd.push(service.where(service.literal(`("${metadata.modelTableName}".${seriesField} + INTERVAL '${seriesDuration} minutes')`), {$lt: service.literal(`"${excludeModel}"."${excludeInfo.endField}"`)}));
                                        //
                                        // $or.push({$and: $subAnd});
                                        // $and.push({$or});

                                        // externalWhere.$and.push({$or: $and});
                                    });

                                }

                                // generate external where sentence
                                const externalWhereSentence = service.repository.model.QueryGenerator.getWhereConditions(externalWhere, metadata.modelTableName, service.repository.model, {});

                                const internalQueryGenerateSeries: any = service.repository.model.QueryGenerator.selectQuery(service.repository.model.tableName, {
                                    where: _where,
                                    tableAs: metadata.modelTableName,
                                    include,
                                    attributes,
                                    model: service.repository.model
                                }, service.repository.model);

                                let mainQueryWithFilters: any = service.repository.model.QueryGenerator.selectQuery(service.repository.model.tableName, {
                                    where: _where,
                                    tableAs: metadata.modelTableName,
                                    include,
                                    attributes,
                                    model: service.repository.model,
                                    subQuery: internalQueryGenerateSeries
                                }, service.repository.model);

                                let groupAttributesText = [`"${metadata.modelTableName}"."${seriesField}"`];
                                const mainAttributesText = [`"${metadata.modelTableName}"."${seriesField}"`];

                                // required attributes by includes
                                Array.from(includeAttributes.keys()).forEach((model: string) => {
                                    groupAttributesText = groupAttributesText.concat(includeAttributes.get(model).map((attribute: string) => `"${model}"."${attribute}"`));
                                });

                                if (inputArtifact.object.config.showEndDate)
                                    mainAttributesText.push(`("${metadata.modelTableName}".${seriesField} + INTERVAL '${seriesDuration} minutes') as "dayEnd"`);

                                mainQueryWithFilters = mainQueryWithFilters.replace(`SELECT "${metadata.modelTableName}".*`, `SELECT ${mainAttributesText.join(', ')}`).slice(0, -1);
                                mainQueryWithFilters = `${mainQueryWithFilters} WHERE ${externalWhereSentence} GROUP BY ${groupAttributesText.join(', ')};`;

                                return from(service.repository.instance.query(mainQueryWithFilters, {nest: true}))
                                    .pipe(map((result: any) => {
                                        const outputArtifact = new NickProcessArtfact();
                                        outputArtifact.kind = ArtfactKind.ANY;
                                        outputArtifact.object = {data: result.map((entity: IEntity) => entity && entity.toJSON ? entity.toJSON() : entity)};
                                        return outputArtifact;
                                    }));
                            }));
                    }));
            }));
    }

    @Hook('18d7258f-d6f5-4163-8051-acf5dfcb2685')
    public seriesGeneration(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        let dates: any[] = [];
        let currDate = moment(inputArtifact.object.config.startAt).milliseconds(0);
        const lastDate = moment(inputArtifact.object.config.endAt).milliseconds(0);

        while (currDate.diff(lastDate) < 0) {
            dates = [...dates, currDate.clone()];
            currDate = currDate.add(inputArtifact.object.config.value, inputArtifact.object.config.kind);
        }

        dates = [...dates, lastDate];

        dates = [...new Set(dates)];

        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;
        outputArtifact.object = dates;

        return of(outputArtifact);
    }

    @Hook('411456f6-035b-42fe-aea5-91ffceb398a3')
    public isDateTimeBetween(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const currentWeekDay = moment().isoWeekday();
        const currentDateTime = moment.utc();
        console.log('SALVOU');
        const auxCurrentDate = moment(currentDateTime).format('YYYY-MM-DD');
        const currentDate = moment(auxCurrentDate);

        const auxCurrentTime = moment(currentDateTime).format('HH-mm-ss');
        const currentTime = moment(auxCurrentTime, 'HH-mm-ss');

        const auxStartAtDate = moment(inputArtifact.object.data.startAt).utc().format('YYYY-MM-DD');
        const startAtDate = moment(auxStartAtDate);
        const auxStartAtTime = moment(inputArtifact.object.data.startAt).utc().format('HH-mm-ss');
        const startAtTime = moment(auxStartAtTime, 'HH-mm-ss');

        const auxEndAtDate = moment(inputArtifact.object.data.endAt).utc().format('YYYY-MM-DD');
        const endAtDate = moment(auxEndAtDate);
        const auxEndAtTime = moment(inputArtifact.object.data.endAt).utc().format('HH-mm-ss');
        const endAtTime = moment(auxEndAtTime, 'HH-mm-ss');
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;

        outputArtifact.object = ((inputArtifact.object.data.weekDays.includes(currentWeekDay)) &&
            (currentDate.isBetween(startAtDate, endAtDate) || currentDate.isSame(startAtDate) || currentDate.isSame(endAtDate)) &&
            (currentTime.isBetween(startAtTime, endAtTime) || currentTime.isSame(startAtTime)));

        return of(outputArtifact);
    }

    @Hook('7d4c3a80-87ed-4c99-a2c1-d4c114851b46')
    public setDatePeriodsPerYear(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        const outputArtifact = new NickProcessArtfact();
        outputArtifact.kind = ArtfactKind.ANY;


        const cron = new CronJob(inputArtifact.object.data.cron);
        const recurrenceEndDate = inputArtifact.object.data.recurrenceEndDate;
        const duration = moment(inputArtifact.object.data.endDate).diff(inputArtifact.object.data.startDate);
        const nextStartDates = cron.nextDates(365);
        if (nextStartDates instanceof  Array) {
            return from(nextStartDates)
                .pipe(takeWhile( (nextStartDate) => {
                    return !moment(nextStartDate).isAfter(moment(recurrenceEndDate));
                }))
                .pipe(map( (nextStartDate ) => {
                    const nextEndDate = moment(nextStartDate).add(duration);
                    return [nextStartDate, nextEndDate];
                }), toArray())
                .pipe(concatMap( (eventChilds: Array<any>) => {
                    outputArtifact.object = eventChilds;
                    return of(outputArtifact);
                })); }
        return of(outputArtifact);
    }
}
